import {TASK_RECURRENCE} from "../../../../model2/recurrence/const";
import {MenuOption} from "../../../../gd-components/popover-menu/popover-menu/const";
import {TaskAction} from "../@const";
import Task from "../../../../model2/task/task";


export type Props = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]
}

export function taskMore_initDuplicate(props: Props, menuOptions:MenuOption[]) {

    if (props.hiddenActions?.includes(TaskAction.DUPLICATE)) return

    const onClickCopy = () => {
        gd.modals.task.duplicate(props.task, ()=>{
        }, {redirectToCopy: false})
    }

    const onClickPro = () => {
        gd.modals.other.upgradeToPro(gd.companyId)
    }

    const disabledDuplicateButton   = !props.task.acl.canDuplicate || props.disabledActions?.includes('duplicate')

    menuOptions.push({
        icon            : "i5-clone",
        label           : "Duplicate",
        disabled        : disabledDuplicateButton,
        onClick         : onClickCopy,
        onClickUpgrade  : onClickPro,
        isPro           : !gd.company.license.isPro
    })
}